import { render, staticRenderFns } from "./CreateCA.vue?vue&type=template&id=8fb5a022"
import script from "./CreateCA.vue?vue&type=script&lang=js"
export * from "./CreateCA.vue?vue&type=script&lang=js"
import style0 from "./CreateCA.vue?vue&type=style&index=0&id=8fb5a022&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports